var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39343 2.80762L21.1924 22.6066L22.6066 21.1924L2.80765 1.3934L1.39343 2.80762Z",
    fill: "#1D2A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1924 1.3934L1.39339 21.1924L2.80761 22.6066L22.6066 2.80762L21.1924 1.3934Z",
    fill: "#1D2A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfCross);
export default __webpack_public_path__ + "static/media/ff-cross.103d3f13a3323d21bdc7f58b00b293db.svg";
export { ForwardRef as ReactComponent };